$(document).ready(function () {
    $('.collapse').on('show.bs.collapse', function () {
        $(this).prev('.card-header').find('.rotate-icon').text('expand_less');
    }).on('hide.bs.collapse', function () {
        $(this).prev('.card-header').find('.rotate-icon').text('expand_more');
    });
});
